if (process.env.NODE_ENV === 'production') {
    module.exports = require('./config.prod.js');
} else if (process.env.NODE_ENV === 'qa') {
    module.exports = require('./config.qa.js');
}
  else {
    module.exports = require('./config.dev.js');
}